import angular from 'angular';

import changeVolumeComponent from './change-volume.component';

export default angular.module('dbm.dashboard.components.widgets.change-volume', [])
.component('dbmChangeVolumeWidget', changeVolumeComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/change-volume/index.js